import { IPromise } from 'angular'
import { ApiResponse, ApiRetailer } from '@vend/types'

import { extractData } from '../../../util/extract-data'
import { $http } from '../../../ng-compat/imports'

const RETAILER_ENDPOINT = '/api/2.0/retailer'

/**
 * Functions for querying the retailer API for retailer settings.
 */

/**
 * Get the current retailer settings.
 *
 * @return {Promise} A promise resolved with the retailer's settings from the server
 */
export function get(): IPromise<ApiRetailer> {
  return $http
    .get<ApiResponse<ApiRetailer>>(RETAILER_ENDPOINT)
    .then(extractData)
}
